export default __webpack_public_path__ + "static/media/IMAGE_5.6e0f4410.png";